<template>
    <footer class="content-footer text-muted">
        <div :title="'Versio numero ' + version + ' käännetty ' + buildtime">Versio: {{ version }}</div>
        <!--
        <div>
            <nav class="nav">
                <a href="https://themeforest.net/licenses/standard" class="nav-link">Licenses</a>
                <a href="#" class="nav-link">Change Log</a>
                <a href="#" class="nav-link">Get Help</a>
            </nav>
        </div>
        -->
    </footer>
</template>

<script>
    export default {
        name: "Footer",
        computed: {
            version () {
                return process.env.VUE_APP_VERSION_NUMBER
            },
            buildtime () {
                return process.env.VUE_APP_VERSION_TIME
            }
        }
    }
</script>

<style scoped>

</style>
